const PhoneIcon = () => (
  <svg
    className="footer-icon"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
    fill="currentColor"
    aria-hidden="true"
  >
    <path d="M15.81 13.19l-2-2a1.007 1.007 0 0 0-1.41 0l-1 1a7.09 7.09 0 0 1-3.3-3.3l1-1a1.007 1.007 0 0 0 0-1.41l-2-2a.998.998 0 0 0-1.42 0L3.3 5.53C2.6 6.23 2.4 7.29 2.8 8.2 4.81 13 8.99 17.2 13.8 19.2c.91.41 1.97.21 2.67-.49l1.25-1.25a.998.998 0 0 0 0-1.42z" />
  </svg>
);

export default PhoneIcon;
